module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot02_point-37f5329c2ae62be777f5014c37b9e758.jpg";